export default {"src":"/_next/static/media/time-fill.108ee2f6.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};